import { CouponType } from 'types/coupon'
import { UserType } from 'types/user'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { db, FirebaseTimestamp } from 'firebase/index'
import { getExpiredDate } from 'reducks/coupon/operations'
import { CouponUserType } from 'types/coupon_user'
import { push } from 'connected-react-router'

const linkUsers = (couponId: string, coupon: CouponType, users: UserType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const batch = db.batch()
    const expiresDate =
      coupon.expires_at || coupon.expires_maxage
        ? getExpiredDate(coupon.expires_at || undefined, coupon.expires_maxage || 0)
        : undefined
    const now = FirebaseTimestamp.now()
    const ref = db.collection('coupons').doc(couponId).collection('coupon_users')
    for (let i = 0; i < users.length; i = (i + 1) | 0) {
      const user = users[i]
      if (!user.user_id) continue
      const couponUser: CouponUserType = {
        user_id: user.user_id,
        status: 'unused',
        created_at: now,
      }
      const couponUserRef = ref.doc()
      if (expiresDate) {
        couponUser.expires_at = FirebaseTimestamp.fromDate(expiresDate)
      }
      batch.set(couponUserRef, couponUser, { merge: true })
    }
    return batch
      .commit()
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(push('/admin/coupon/list/complete'))
      })
      .catch((error) => {
        console.error(error)
        dispatch(hideLoadingAction())
      })
  }
}

export default linkUsers
